import { Flex } from "antd";
import dayjs from "dayjs";

export const QuoteExpTime = ({ quoteExpTime, maxMinutes = 119 }: { quoteExpTime: string; maxMinutes?: number }) => {
  if (!quoteExpTime) {
    return <span className="text-description text-xs">Срок действия</span>;
  }

  const now = dayjs();
  const expTime = dayjs(quoteExpTime);
  const totalSeconds = expTime.diff(now, "second");
  const totalMinutes = expTime.diff(now, "minute");

  if (totalSeconds <= 0) {
    return <span className="text-description text-xs">Срок действия истек</span>;
  }

  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  const timeLabel =
    totalSeconds < 60
      ? `меньше минуты`
      : `${hours ? `${hours} ч.` : ""} ${String(minutes).padStart(2, "0")} мин.`.trim();

  return totalMinutes <= maxMinutes ? (
    <Flex vertical>
      <span className="text-description text-xs">Срок действия:</span>
      <span className="text-description text-xs" style={{ color: "red" }}>
        {timeLabel}
      </span>
    </Flex>
  ) : (
    <span className="text-description text-xs">Срок действия</span>
  );
};
